"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTRSummarySchema = void 0;
const model_schema_1 = require("../base/model.schema");
const yup_1 = require("yup");
exports.CTRSummarySchema = model_schema_1.Schema.shape({
    agentID: (0, yup_1.string)().notRequired(),
    agentName: (0, yup_1.string)().notRequired(),
    queueID: (0, yup_1.string)().notRequired(),
    username: (0, yup_1.string)().notRequired(),
    inQueueDuration: (0, yup_1.number)().notRequired(),
    queueName: (0, yup_1.string)().notRequired(),
    answered: (0, yup_1.boolean)().required(),
    agentInteractionDuration: (0, yup_1.number)().notRequired(),
    afterContactWorkDuration: (0, yup_1.number)().notRequired(),
    description: (0, yup_1.string)().notRequired(),
    numberOfHolds: (0, yup_1.number)().notRequired(),
    holdDuration: (0, yup_1.number)().notRequired(),
    topHierarchyGroupID: (0, yup_1.string)().notRequired(),
    hierarchyStructure: (0, yup_1.string)().notRequired(),
    initiationMethod: (0, yup_1.mixed)().oneOf([
        'INBOUND',
        'OUTBOUND',
        'TRANSFER',
        'CALLBACK',
        'API',
        'QUEUE_TRANSFER',
        'EXTERNAL_OUTBOUND',
        'MONITOR',
        'DISCONNECT',
    ]),
    instanceID: (0, yup_1.string)().required(),
    companyID: (0, yup_1.string)().required(),
    routingProfileID: (0, yup_1.string)().notRequired(),
    initiationTimestamp: (0, yup_1.number)().required(),
    connectedToAgentTimestamp: (0, yup_1.number)().notRequired(),
    connectedToSystemTimestamp: (0, yup_1.number)().notRequired(),
    disconnectTimestamp: (0, yup_1.number)().notRequired(),
    disconnectReason: (0, yup_1.string)().notRequired(),
    longestHoldDuration: (0, yup_1.number)().notRequired(),
    agentConnectionAttempts: (0, yup_1.number)().notRequired(),
    systemEndpointAddress: (0, yup_1.string)().required(),
    customerEndpointAddress: (0, yup_1.string)().notRequired(),
    expiry: (0, yup_1.number)().notRequired(),
    nextContactID: (0, yup_1.string)().notRequired(),
    initialContactID: (0, yup_1.string)().notRequired(),
    channel: (0, yup_1.mixed)().oneOf(['VOICE', 'CHAT', 'EMAIL', 'TASK']).default('VOICE'),
    chatTranscript: (0, yup_1.string)().notRequired(),
    attributes: (0, yup_1.mixed)().required(),
});
